module.exports = __webpack_public_path__ + "img/flag-jp2.3aa6dd57.svg";